// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid4 {
  margin-top: 40px;
}

.grid4 .table_header:nth-child(-n+4), .grid4 .table_small:nth-child(-n+4) {
  width: 20%;
}

.grid4 .table_header:nth-child(2), .grid4 .table_small:nth-child(2) {
  width: 50%;
}

.grid4 .table_header:last-child, .grid4 .table_small:last-child {
  width: 10%;
}

.grid4 .table_small p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/common/document-template/document-template.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,UAAA;AAEJ;;AAAA;EACI,UAAA;AAGJ;;AADA;EACI,UAAA;AAIJ;;AAFA;EACI,SAAA;AAKJ","sourcesContent":[".grid4{\r\n    margin-top: 40px;\r\n}\r\n.grid4 .table_header:nth-child(-n+4), .grid4 .table_small:nth-child(-n+4){\r\n    width: 20%;\r\n}\r\n.grid4 .table_header:nth-child(2), .grid4 .table_small:nth-child(2){\r\n    width: 50%;\r\n}\r\n.grid4 .table_header:last-child, .grid4 .table_small:last-child{\r\n    width: 10%;\r\n}\r\n.grid4 .table_small p{\r\n    margin: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
